import { call, put, takeLatest } from "redux-saga/effects";
import { push } from "react-router-redux";
import swal from "sweetalert";
import api from "services/api";
import vouchers from "services/vouchers";
import cube from "services/cube";
import moment from "moment";
import FileDownload from "js-file-download";

import {
  Creators as BenefitsActions,
  Types as BenefitsTypes,
} from "store/ducks/benefits";

function* getBenefitRequest(action) {
  try {
    const { id } = action.payload;
    const url = `/experience/vouchers/${id}`;
    const response = yield call(vouchers.get, url);

    yield put(BenefitsActions.getBenefitSuccess(response.data));
  } catch (error) {
    yield put(BenefitsActions.getBenefitFailure());
  }
}

function* getBenefitsRequest(action) {
  try {
    const { page, filters } = action.payload;
    let filter = "";

    if (filters !== null) {
      const store_id =
        filters.store.value !== "" ? `&store_id=${filters.store.value}` : "";
      const start_at =
        filters.start_at !== null
          ? `&start_at=${moment(filters.start_at).format("YYYY-MM-DD")}`
          : "";
      const end_at =
        filters.end_at !== null
          ? `&end_at=${moment(filters.end_at).format("YYYY-MM-DD")}`
          : "";
      const category_id =
        filters.type.value !== "" ? `&category_id=${filters.type.value}` : "";
      const channel =
        filters.channel.value !== ""
          ? `&channel_id=${filters.channel.value}`
          : "";
      const status =
        filters.status.value !== "" ? `&status=${filters.status.value}` : "";
      const app_only =
        filters.app_only.value !== ""
          ? `&extra_data[app_only]=${filters.app_only.value}`
          : "";
      const commercialCampaign =
        filters.commercialCampaign.value !== ""
          ? `&campaign_id=${filters.commercialCampaign.value}`
          : "";
      const description = filters.description
        ? `&description=${filters.description}`
        : "";

      filter = `${store_id}${start_at}${end_at}${category_id}${status}${app_only}${channel}${commercialCampaign}${description}`;
    }

    const url = `/experience/vouchers/backoffice?type=percentage&page=${page}&per=25${filter}`;
    const response = yield call(vouchers.get, url);

    yield put(BenefitsActions.getBenefitsSuccess(response.data));
  } catch (error) {
    yield put(BenefitsActions.getBenefitsFailure());
  }
}

function* createBenefitRequest(action) {
  try {
    const { data } = action.payload;
    const url = "/experience/vouchers/benefits";
    yield call(vouchers.post, url, data);

    yield put(push("/benefits/list"));
    yield call(
      swal,
      "Adicionado",
      "Benefício está sendo criado, aguarde alguns minutos.",
      "success"
    );
    yield put(BenefitsActions.createBenefitSuccess());
  } catch (error) {
    yield call(
      swal,
      "Falha ao atualizar",
      "Não foi possível criar o benefício.",
      "error"
    );
    yield put(BenefitsActions.createBenefitFailure());
  }
}

function* updateBenefitRequest(action) {
  try {
    const { id, data } = action.payload;
    const { filters } = data;
    const url = `/experience/vouchers/benefits/${id}`;
    yield call(vouchers.put, url, data);

    yield put(push({ pathname: "/benefits/list", filters }));
    yield call(
      swal,
      "Atualizado",
      "Benefício atualizado com sucesso!",
      "success"
    );
    yield put(BenefitsActions.updateBenefitSuccess());
  } catch (error) {
    yield call(
      swal,
      "Falha ao atualizar",
      "Não foi possível atualizar o benefício.",
      "error"
    );
    yield put(BenefitsActions.updateBenefitFailure());
  }
}

function* getBenefitCategoriesRequest(action) {
  try {
    const { query } = action.payload;
    const url = `experience/v2/voucher_categories?search=${query}&per=30`;
    const response = yield call(api.get, url);

    const { data } = response.data;

    const categories = {
      data: data.filter(
        (category) => category.attributes.external_id !== "aniversario"
      ),
    };

    yield put(BenefitsActions.getBenefitCategoriesSuccess(categories));
  } catch (error) {
    yield put(BenefitsActions.getBenefitCategoriesFailure());
  }
}

function* getBenefitChannelsRequest(action) {
  try {
    const { query } = action.payload;
    const url = `channels?search=${query}&per=30`;
    const response = yield call(vouchers.get, url);

    yield put(BenefitsActions.getBenefitChannelsSuccess(response.data));
  } catch (error) {
    yield put(BenefitsActions.getBenefitChannelsFailure());
  }
}

function* getBenefitCommercialCampaignsRequest(action) {
  try {
    const { query, active } = action.payload;
    const url = `experience/commercial_campaigns?search=${query}&per=9999`;
    const response = yield call(vouchers.get, url, {
      params: {
        status_value: active !== undefined ? active : null,
      },
    });

    yield put(
      BenefitsActions.getBenefitCommercialCampaignsSuccess(response.data)
    );
  } catch (error) {
    yield put(BenefitsActions.getBenefitCommercialCampaignsFailure());
  }
}

async function* exportReportBenefitsRequest(action) {
  try {
    const { query } = action.payload;

    const url = `experience/v2/voucher_products/${query.id}`;
    const response = await api.post(url, {
      responseType: "blob",
    });

    FileDownload(response.data, `${query.title}.csv`);

    yield put(BenefitsActions.getBenefitRegionsSuccess(response.data));
  } catch {
    yield put(BenefitsActions.getBenefitRegionsFailure());
  }
}
function* getBenefitRegionsRequest(action) {
  try {
    const url = `regions?per=30`;
    const response = yield call(vouchers.get, url);

    yield put(BenefitsActions.getBenefitRegionsSuccess(response.data));
  } catch (error) {
    yield put(BenefitsActions.getBenefitRegionsFailure());
  }
}

function* getBenefitStoresRequest(action) {
  try {
    const { region } = action.payload;
    const response = yield call(vouchers.get, "/stores", {
      params: {
        search_by_region_id: region,
        per: 9999,
      },
    });

    yield put(BenefitsActions.getBenefitStoresSuccess(response.data));
  } catch (error) {
    yield put(BenefitsActions.getBenefitStoresFailure());
  }
}

function* getBenefitProductTypesRequest(action) {
  try {
    const { query } = action.payload;
    const url = `product_types?search=${query}&per=30`;
    const response = yield call(vouchers.get, url);

    yield put(BenefitsActions.getBenefitProductTypesSuccess(response.data));
  } catch (error) {
    yield put(BenefitsActions.getBenefitProductTypesFailure());
  }
}

function* getBenefitSectionsRequest(action) {
  try {
    const { query } = action.payload;
    const url = `sections?search=${query}&per=30`;
    const response = yield call(vouchers.get, url);

    yield put(BenefitsActions.getBenefitSectionsSuccess(response.data));
  } catch (error) {
    yield put(BenefitsActions.getBenefitSectionsFailure());
  }
}

function* getBenefitSubSectionsRequest(action) {
  try {
    const { query, section } = action.payload;
    const url = `sub_sections?search=${query}${
      section !== null ? `&section_id=${section}` : ""
    }&per=30`;
    const response = yield call(vouchers.get, url);

    yield put(BenefitsActions.getBenefitSubSectionsSuccess(response.data));
  } catch (error) {
    yield put(BenefitsActions.getBenefitSubSectionsFailure());
  }
}

function* getBenefitProductsRequest(action) {
  try {
    const { query } = action.payload;

    if (query.length >= 2) {
      const url = `store/v2/products?skus=${query}&per=50`;
      const response = yield call(api.get, url);

      yield put(BenefitsActions.getBenefitProductsSuccess(response.data));
    } else {
      yield put(BenefitsActions.getBenefitProductsSuccess({ data: [] }));
    }
  } catch (error) {
    yield put(BenefitsActions.getBenefitProductsFailure());
  }
}

function* getBenefitPassionsRequest(action) {
  try {
    const { query } = action.payload;
    const url = `classification/passions?search=${query}&per=30`;
    const response = yield call(vouchers.get, url);

    yield put(BenefitsActions.getBenefitPassionsSuccess(response.data));
  } catch (error) {
    yield put(BenefitsActions.getBenefitPassionsFailure());
  }
}

function* getBenefitSellersRequest(action) {
  try {
    const url = `store/v2/sellers?per=30`;
    const response = yield call(api.get, url);

    yield put(BenefitsActions.getBenefitSellersSuccess(response.data));
  } catch (error) {
    yield put(BenefitsActions.getBenefitSellersFailure());
  }
}

function* getBenefitTypesRequest(action) {
  try {
    const { query, status_value } = action.payload;

    const url = `/experience/voucher_configurations?search=${query}&per=100`;
    const response = yield call(vouchers.get, url, {
      params: {
        status_value,
      },
    });

    yield put(BenefitsActions.getBenefitTypesSuccess(response.data));
  } catch (error) {
    yield put(BenefitsActions.getBenefitTypesFailure());
  }
}

function filterSearchBenefits({ filters }) {
  return {
    place_id: filters.place_id.value !== "" ? filters.place_id.value : null,
    date_start:
      filters.date_start !== null
        ? moment(filters.date_start).format("YYYY-MM-DD")
        : null,
    date_end:
      filters.date_end !== null
        ? moment(filters.date_end).format("YYYY-MM-DD")
        : null,
    sections_ids:
      filters.section_id.value !== "" ? filters.section_id.value : null,
    discount: filters.discount.value !== "" ? filters.discount.value : null,
    voucher_id:
      filters.voucher_id.value !== "" ? filters.voucher_id.value : null,
    campaign_id:
      filters.campaign_id.value !== "" ? filters.campaign_id.value : null,
    channels_ids: !!filters.channels.length
      ? filters.channels.map((channel) => channel.value).join(",")
      : null,
    app_only: filters.app_only.value !== "" ? filters.app_only.value : null,
    // all_store_only_value:
    //   filters.all_store_only_value.value !== ""
    //     ? filters.all_store_only_value.value
    //     : null,
  };
}

function* searchBenefitsRequest(action) {
  try {
    const { filters } = action.payload;
    const url = `list/benefits`;
    const params = yield call(filterSearchBenefits, filters);
    const response = yield call(cube.get, url, {
      params,
    });

    yield put(BenefitsActions.searchBenefitsSuccess(response));
  } catch (error) {
    yield put(BenefitsActions.searchBenefitsFailure());
  }
}

function* approveBenefitRequest(action) {
  try {
    const { id, data } = action.payload;
    const { filters } = data;
    const url = `experience/vouchers/${id}/approve`;
    yield call(vouchers.post, url);

    yield put(push({ pathname: "/benefits/list", filters }));
    yield call(swal, "Aprovado", "Benefício aprovado com sucesso!", "success");
    yield put(BenefitsActions.approveBenefitSuccess());
  } catch (error) {
    yield call(
      swal,
      "Falha ao aprovar",
      "Não foi possível aprovar o benefício.",
      "error"
    );
    yield put(BenefitsActions.approveBenefitFailure());
  }
}

function* repproveBenefitRequest(action) {
  try {
    const { id, data } = action.payload;

    const { filters } = data;
    const url = `experience/vouchers/${id}/reprove`;
    yield call(vouchers.post, url, {
      voucher_status_obs: data.voucher.obs,
    });

    yield put(push({ pathname: "/benefits/list", filters }));
    yield call(
      swal,
      "Reprovado",
      "Benefício reprovado com sucesso!",
      "success"
    );
    yield put(BenefitsActions.repproveBenefitSuccess());
  } catch (error) {
    yield call(
      swal,
      "Falha ao reprovar",
      "Não foi possível reprovar o benefício.",
      "error"
    );
    yield put(BenefitsActions.repproveBenefitFailure());
  }
}

export default function* saga() {
  yield takeLatest(BenefitsTypes.GET_REQUEST, getBenefitRequest);
  yield takeLatest(BenefitsTypes.GET_LIST_REQUEST, getBenefitsRequest);
  yield takeLatest(BenefitsTypes.CREATE_REQUEST, createBenefitRequest);
  yield takeLatest(BenefitsTypes.UPDATE_REQUEST, updateBenefitRequest);
  yield takeLatest(
    BenefitsTypes.GET_CATEGORIES_REQUEST,
    getBenefitCategoriesRequest
  );
  yield takeLatest(
    BenefitsTypes.GET_CHANNELS_REQUEST,
    getBenefitChannelsRequest
  );
  yield takeLatest(
    BenefitsTypes.GET_COMMERCIAL_CAMPAIGN_REQUEST,
    getBenefitCommercialCampaignsRequest
  );
  yield takeLatest(BenefitsTypes.GET_REGIONS_REQUEST, getBenefitRegionsRequest);
  yield takeLatest(
    BenefitsTypes.EXPORT_REPORT_REQUEST,
    exportReportBenefitsRequest
  );
  yield takeLatest(BenefitsTypes.GET_STORES_REQUEST, getBenefitStoresRequest);
  yield takeLatest(
    BenefitsTypes.GET_PRODUCT_TYPES_REQUEST,
    getBenefitProductTypesRequest
  );
  yield takeLatest(
    BenefitsTypes.GET_SECTIONS_REQUEST,
    getBenefitSectionsRequest
  );
  yield takeLatest(
    BenefitsTypes.GET_SUB_SECTIONS_REQUEST,
    getBenefitSubSectionsRequest
  );
  yield takeLatest(
    BenefitsTypes.GET_PRODUCTS_REQUEST,
    getBenefitProductsRequest
  );
  yield takeLatest(
    BenefitsTypes.GET_PASSIONS_REQUEST,
    getBenefitPassionsRequest
  );
  yield takeLatest(BenefitsTypes.GET_SELLERS_REQUEST, getBenefitSellersRequest);
  yield takeLatest(BenefitsTypes.GET_TYPES_REQUEST, getBenefitTypesRequest);
  yield takeLatest(BenefitsTypes.SEARCH_REQUEST, searchBenefitsRequest);
  yield takeLatest(BenefitsTypes.APPROVE_REQUEST, approveBenefitRequest);
  yield takeLatest(BenefitsTypes.REPPROVE_REQUEST, repproveBenefitRequest);
}
